// DiagnosticsLogger — local event logging for standalone/kiosk diagnostics.
// Online: no-op unless ?diag=1 (then console.debug). Kiosk: the Machine Service
// provides a `sink` that writes to a local rotating file. Never throws.

export function createDiagnosticsLogger({ mode, gameId, sink } = {}) {
  let urlDiag = false;
  try {
    if (typeof window !== 'undefined' && window.location) {
      urlDiag = new URLSearchParams(window.location.search).get('diag') === '1';
    }
  } catch (_e) { /* ignore */ }

  const consoleOn = mode === 'kiosk' || urlDiag;

  const emit = (level, type, data) => {
    const record = { ts: new Date().toISOString(), gameId: gameId || null, mode: mode || null, level, type, data: data || null };
    if (typeof sink === 'function') {
      try { sink(record); } catch (_e) { /* logging must never break the game */ }
    }
    if (consoleOn) {
      const fn = level === 'error' ? console.error : level === 'warn' ? console.warn : console.debug;
      try { fn('[betohalics-diag]', type, record); } catch (_e) { /* ignore */ }
    }
  };

  return {
    event: (type, data) => emit('info', type, data),
    warn: (type, data) => emit('warn', type, data),
    error: (type, data) => emit('error', type, data),
  };
}
